import { IconInterface } from '../interfaces/icon.interface';

export const Stack = (props: IconInterface) => {
	const {
		color = '#494C83',
		width = 18,
		height = 18,
		strokeWidth = '1.6',
	} = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
